import React from 'react'
import LoginForm from '../../../components/Authentication/LoginForm'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet';

export default function Index() {

    // useEffect(() => {
    //     // Mettre à jour le titre de la page
    //     document.title = "Page de connexion - Events";
        
    // }, []);

    return (
        <>
            <Helmet>
                <title>Connexion - Espace Organisateur</title>

                <meta
                name="description"
                content="Connectez-vous à votre espace organisateur sur Events. Gérez vos événements, vendez des billets et suivez vos ventes en temps réel grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />

                <meta
                name="keywords"
                content="connexion Events, espace organisateur, connexion billetterie CI, gestion événements Côte d'Ivoire, connexion organisateur événementiel, plateforme billetterie événements Afrique"
                />

                <meta name="author" content="Events" />

                {/* Open Graph */}
                <meta property="og:title" content="Connexion - Events | Espace Organisateur de Billetterie Événementielle" />
                <meta
                property="og:description"
                content="Connectez-vous à votre espace organisateur sur Events. Gérez vos événements, vendez des billets et suivez vos ventes en temps réel grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />
                <meta property="og:image" content="https://eventsbilletterie.com/assets/images/mainpage-organizer-dashbord.png" />
                <meta property="og:url" content="https://eventsbilletterie.com/login" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Connexion - Events | Espace Organisateur de Billetterie Événementielle" />
                <meta
                name="twitter:description"
                content="Connectez-vous à votre espace organisateur sur Events. Gérez vos événements, vendez des billets et suivez vos ventes en temps réel grâce à notre plateforme de billetterie événementielle en Côte d'Ivoire."
                />
                <meta name="twitter:image" content="https://eventsbilletterie.com/assets/images/mainpage-organizer-dashbord.png" />
                <meta name="twitter:site" content="@events_billetterie" /> {/* Remplace par ton handle Twitter si applicable */}

                {/* Canonical URL */}
                <link rel="canonical" href="https://eventsbilletterie.com/login" />
            </Helmet>

            <div className="nc-PageLogin ">
                <div className="container mb-24 lg:mb-16">
                    <h2 className="my-10 mb-5 flex items-center text-2xl leading-[115%] md:text-3xl md:leading-[115%] font-bold text-neutral-900 dark:text-neutral-100 justify-center">
                        Connexion
                    </h2>
                    <div className="relative text-center max-w-md mx-auto space-y-11">
                        <span className="relative inline-block px-4 text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
                            Connectez-vous à votre espace organisateur sur Events Billetterie.
                        </span>
                    </div>
                    <div className="max-w-md mx-auto space-y-6 mt-12">
                    
                        <LoginForm />
                        <span className="block text-center text-neutral-700 dark:text-neutral-300">
                            Pas encore de compte?{' '} <Link to="/create-account" className='font-medium text-primary-6000'>Inscrivez-vous</Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}
